























import { Component, Vue, Prop } from 'vue-property-decorator';
import { GQL_productListSearch_products } from '@/queries/__generated__/productListSearch';
import gql from 'graphql-tag';

const DELETE_PRODUCT = gql`
  mutation deleteProduct($id: ID!) {
    deleteProduct(
      input: {
        id: $id
      }
    ) {
      product {
        id
      }
    }
  }
`;

@Component
export default class ProductDeleteButton extends Vue {
  @Prop() public product!: GQL_productListSearch_products;
  public DELETE_PRODUCT = DELETE_PRODUCT;

  public confirmDelete(confirmMutation: () => {}) {
    this.$sPopup.confirm(``, {
      title: this.$t('PopupTitle.confirmDelete'),
      message: this.$t('PopupBody.confirmDelete', { thing: `${this.product.number} - ${this.product.name}` }),
      onConfirm: confirmMutation,
    });
  }
}
